import styled from 'styled-components';

export const Layout = styled.div`
  height: 100vh;
  width: 100vw;

  background: center/cover no-repeat url('./assets/oldTheme/background.jpg');
  display: grid;
  grid-template-columns: 4vmin 6vmin auto 6vmin 4vmin;
  grid-template-rows: 6vmin auto;
  overflow: hidden;
`;